import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { RceConfigKeys } from '@instructure/quiz-common';
import { hasAllPropsForRcs, areLtiAppsConfigured } from './rceConfigUtils';
var mapRcs = function mapRcs(rcsParams, canvasConfig) {
  if (rcsParams && hasAllPropsForRcs(rcsParams) && canvasConfig) {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RceConfigKeys.canvasUserId, rcsParams.canvasUserId), RceConfigKeys.contextId, rcsParams.contextId), RceConfigKeys.contextType, rcsParams.contextType), RceConfigKeys.rcsHost, rcsParams.rcsHost), RceConfigKeys.rcsJwt, rcsParams.jwt), RceConfigKeys.rcsJwtRefreshFn, rcsParams.refreshToken), RceConfigKeys.canvasConfig, canvasConfig);
  } else {
    return null;
  }
};
var mapLtiApps = function mapLtiApps(canvasConfig, ltiAppParams) {
  if (!areLtiAppsConfigured(canvasConfig, ltiAppParams)) return null;
  return _defineProperty(_defineProperty(_defineProperty({}, RceConfigKeys.canvasToolId, ltiAppParams.canvasToolId), RceConfigKeys.ltiIframeAllowances, canvasConfig.LTI_LAUNCH_FRAME_ALLOWANCES), RceConfigKeys.editorButtons, canvasConfig.editorButtons);
};
var rendererEnhancement = function rendererEnhancement(rendererParams) {
  return _defineProperty({}, RceConfigKeys.canvasOrigin, (rendererParams === null || rendererParams === void 0 ? void 0 : rendererParams.canvasOrigin) || null);
};

// If you are removing the displayOldLinks feature flag, please strongly consider leaving
// the mapFeatureFlags functionality in place in case new feature flags are added in the future.
var mapFeatureFlags = function mapFeatureFlags(flags) {
  return _defineProperty({}, RceConfigKeys.displayOldLinks, (flags === null || flags === void 0 ? void 0 : flags.displayOldLinks) || false);
};
export var mapParamsToRceConfigContext = function mapParamsToRceConfigContext(rcsParams, rendererParams, canvasConfig, ltiAppParams, flags) {
  return {
    rcs: mapRcs(rcsParams, canvasConfig),
    rendererEnhancement: rendererEnhancement(rendererParams),
    ltiApps: mapLtiApps(canvasConfig, ltiAppParams),
    featureFlags: mapFeatureFlags(flags)
  };
};